module.exports = __webpack_public_path__ + "media/components/assets/img/icons/bulb-blue-b457675e9bacf8c81be67abfcc72023f.svg";